
import { UserProfile } from '@/types/database.types';

/**
 * Helper function to safely extract requestor info
 */
export const extractRequestorInfo = (requestorData: any): UserProfile | null => {
  console.log('Extracting requestor info:', requestorData);
  
  if (!requestorData || typeof requestorData !== 'object') {
    console.log('No requestor data or invalid format');
    return null;
  }
  
  // Handle array case (when it comes from a join)
  if (Array.isArray(requestorData) && requestorData.length > 0) {
    requestorData = requestorData[0];
  }
  
  // Handle the case where requestorData is already a proper UserProfile
  if (requestorData.id && requestorData.role) {
    const extracted = {
      id: requestorData.id,
      first_name: requestorData.first_name || undefined,
      last_name: requestorData.last_name || undefined,
      email: requestorData.email || undefined,
      role: requestorData.role,
      created_at: requestorData.created_at,
      updated_at: requestorData.updated_at,
      status: requestorData.status || 'active'
    };
    
    console.log('Extracted requestor info:', extracted);
    return extracted;
  }
  
  console.log('Requestor data does not have required fields (id, role)');
  return null;
};
